<template>
    <div class="container">
        <div class="col-md-12">
            <h2>{{ labels.title }}</h2>
        </div>

        <b-container>
            <!-- Botón Crear Grupo -->
            <b-row class="mb-4 justify-content-end">
                <b-col md="auto">
                    <b-button @click="mostrarModalCrear" size="lg" variant="outline-primary">
                        <b-icon icon="plus-circle" class="me-2"></b-icon>
                        {{ labels.createGroup }}
                    </b-button>
                </b-col>
            </b-row>

            <!-- Buscadores -->
            <b-row class="mb-4 justify-content-center">
                <b-col md="8">
                    <b-row class="align-items-end">
                        <b-col md="4">
                            <label class="d-block fw-bold text-dark mb-2" style="font-size: 1.1rem;">
                                {{ labels.searchByInterco }}
                            </label>
                            <b-form-input v-model="searchInterco" @input="searchOnTableInterco" class="form-control"
                                placeholder="Buscar por interco...">
                            </b-form-input>
                        </b-col>

                        <b-col md="4">
                            <label class="d-block fw-bold text-dark mb-2" style="font-size: 1.1rem;">
                                {{ labels.searchByDescription }}
                            </label>
                            <b-form-input v-model="searchDescripcion" @input="searchOnTableDescripcion"
                                class="form-control" placeholder="Buscar por descripción...">
                            </b-form-input>
                        </b-col>

                        <b-col md="4" class="d-flex align-items-end">
                            <b-button @click="borraCriterio" variant="outline-secondary" class="w-100"
                                style="height: 38px;">
                                <b-icon icon="arrow-counterclockwise" class="me-2"></b-icon>
                                {{ labels.clear }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>

            <!-- Contador -->
            <b-row class="mb-3 justify-content-center">
                <b-col md="6">
                    <div class="text-muted text-center">
                        {{ labels.showing }} <strong>{{ visibleItems.length }}</strong> {{ labels.of }}
                        <strong>{{ listGruposIntercos.length }}</strong> {{ labels.records }}
                    </div>
                </b-col>
            </b-row>

            <!-- Tabla de Grupos Intercos -->
            <b-row class="justify-content-center">
                <b-col md="8">
                    <div class="table-responsive">
                        <table class="table table-hover table-bordered mb-2">
                            <thead style="background-color: #4a90e2;">
                                <tr>
                                    <th scope="col" class="text-center text-white border-0"
                                        style="font-weight: 600; width: 120px;">
                                        Interco</th>
                                    <th scope="col" class="text-center text-white border-0" style="font-weight: 600;">
                                        Descripción</th>
                                    <th scope="col" class="text-center text-white border-0"
                                        style="font-weight: 600; width: 150px;">
                                        Cuentas Asociadas</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="grupo in visibleItems" :key="grupo.id" @click="editarGrupo(grupo)"
                                    class="clickable-row" style="cursor: pointer;">
                                    <td class="text-center" style="width: 120px;">
                                        <strong class="text-dark">{{ grupo.interco }}</strong>
                                    </td>
                                    <td class="text-center">{{ grupo.descripcion }}</td>
                                    <td class="text-center" style="width: 150px;">
                                        <template v-if="grupo.cuentas">
                                            <div class="cuentas-lista">
                                                <strong v-for="(cuenta, index) in grupo.cuentas.split(',')"
                                                    :key="index">
                                                    {{ cuenta.trim() }}
                                                    <span v-if="index < grupo.cuentas.split(',').length - 1">, </span>
                                                </strong>
                                            </div>
                                        </template>
                                        <span v-else class="text-muted">
                                            Sin cuentas
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-col>
            </b-row>

            <!-- Mensaje cuando no hay datos -->
            <div v-if="listGruposIntercos.length === 0" class="mt-4 text-center">
                <div class="h4 text-muted">
                    <b-icon icon="inbox" class="me-2"></b-icon>
                    {{ labels.noData }}
                </div>
            </div>
        </b-container>

        <!-- Loading Spinner -->
        <div class="loadingSpinner" :class="{ active: isLoading }">
            <b-spinner variant="primary"></b-spinner>
        </div>

        <!-- Modal para Crear/Editar Grupo -->
        <b-modal v-model="showModal" :title="modoEdicion ? labels.editGroup : labels.createGroup" size="xl" hide-footer
            scrollable>
            <b-form @submit.prevent="guardarGrupo">
                <b-row>
                    <b-col md="6">
                        <b-form-group :label="labels.interco" label-class="fw-bold">
                            <b-form-input type="number" v-model="formulario.interco" required
                                :placeholder="labels.enterInterco" :disabled="modoEdicion"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group :label="labels.description" label-class="fw-bold">
                            <b-form-input v-model="formulario.descripcion" required :maxlength="60"
                                :placeholder="labels.enterDescription"></b-form-input>
                            <small class="text-muted">{{ formulario.descripcion.length }}/60 {{
                                labels.characters }}</small>
                        </b-form-group>
                    </b-col>
                </b-row>

                <!-- Sección de Registros Existentes (solo en edición) -->
                <div v-if="modoEdicion && registrosActivos.length > 0" class="mt-4">
                    <b-card :header="labels.existingRecords" header-class="fw-bold bg-light">
                        <b-alert variant="info" show class="mb-3">
                            <b-icon icon="info-circle" class="me-2"></b-icon>
                            {{ labels.existingRecordsHelp }}
                        </b-alert>

                        <div class="table-responsive">
                            <table class="table table-sm table-hover">
                                <thead>
                                    <tr>
                                        <th>Compañía</th>
                                        <th>Cuenta</th>
                                        <th class="text-center">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="registro in registrosActivos" :key="registro.id">
                                        <td>
                                            <strong>{{ registro.compania_nombre || 'Compañía ' + registro.id_compania
                                                }}</strong>
                                        </td>
                                        <td>
                                            <strong v-if="registro.cuentas">{{ registro.cuentas }}</strong>
                                            <span v-else class="text-muted">Sin cuenta</span>
                                        </td>
                                        <td class="text-center">
                                            <b-button-group size="sm">
                                                <b-button @click.stop="editarRegistroExistente(registro)"
                                                    variant="outline-primary" size="sm"
                                                    class="btn-icon-minimal md-icon-button">
                                                    <md-icon class="edit-icon">edit</md-icon>
                                                </b-button>
                                                <b-button @click.stop="eliminarRegistro(registro)"
                                                    variant="outline-danger" size="sm"
                                                    class="btn-icon-minimal md-icon-button">
                                                    <md-icon class="delete-icon">delete_outline</md-icon>
                                                </b-button>
                                            </b-button-group>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </b-card>
                </div>

                <!-- Línea divisoria -->
                <hr v-if="modoEdicion" class="my-4">

                <!-- Sección para agregar/editar un registro -->
                <b-card :header="modoEdicion && registroActual.id ? labels.editRecord : labels.addRecord"
                    header-class="fw-bold bg-light" class="mt-4">
                    <b-alert variant="info" show class="mb-3">
                        <b-icon icon="info-circle" class="me-2"></b-icon>
                        {{ labels.accountSelectionHelp }}
                    </b-alert>

                    <!-- Filtro de Compañías -->
                    <b-form-group :label="labels.selectCompany" label-class="fw-bold">
                        <b-form-select v-model="companiaSeleccionada" @change="cargarCuentasPorCompania"
                            :options="companiasOptions" :disabled="isLoadingCuentas || companias.length === 0"
                            :state="validarCompaniaUnica()">
                            <template #first>
                                <b-form-select-option :value="null">
                                    {{ companias.length === 0 ? labels.loadingCompanies : labels.selectCompanyOption }}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-form-invalid-feedback v-if="!validarCompaniaUnica()">
                            Esta compañía ya tiene una cuenta asignada en este grupo
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <!-- Solo mostrar cuentas si se seleccionó compañía -->
                    <div v-if="companiaSeleccionada">
                        <b-form-group :label="labels.vigency" label-class="fw-bold">
                            <b-form-select v-model="vigenciaSeleccionada" @change="cargarCuentasPorCompania"
                                :options="vigenciasOptions" :disabled="isLoadingCuentas || vigencias.length === 0">
                                <template #first>
                                    <b-form-select-option :value="null">
                                        {{ labels.selectVigency }}
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>

                        <!-- Buscador de cuentas -->
                        <b-form-group :label="labels.searchAccount" label-class="fw-bold"
                            v-if="cuentasDisponibles.length > 0">
                            <b-input-group>
                                <b-form-input v-model="searchCuenta" :placeholder="labels.searchAccountPlaceholder"
                                    @input="filtrarCuentas"></b-form-input>
                                <b-input-group-append>
                                    <b-button variant="outline-secondary" @click="searchCuenta = ''; filtrarCuentas()">
                                        <b-icon icon="x"></b-icon>
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>

                        <!-- Lista de cuentas seleccionables -->
                        <div v-if="cuentasDisponibles.length > 0" class="mt-3">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <h6 class="mb-0">{{ labels.availableAccounts }}</h6>
                                <small class="text-muted" v-if="cuentaSeleccionada">
                                    {{ obtenerNombreCuentaSeleccionada() }}
                                </small>
                            </div>

                            <div class="cuentas-container" style="max-height: 200px; overflow-y: auto;">
                                <b-list-group>
                                    <b-list-group-item v-for="cuenta in cuentasFiltradas" :key="cuenta.id"
                                        class="d-flex justify-content-between align-items-center"
                                        :class="{ 'bg-light': cuentaSeleccionada === cuenta.id }">
                                        <div class="d-flex align-items-center w-100">
                                            <b-form-radio v-model="cuentaSeleccionada" :value="cuenta.id" class="mr-3"
                                                @change="actualizarCuentaSeleccionada">
                                                <span class="ml-2">
                                                    <strong>{{ cuenta.codigo }}</strong> - {{ cuenta.nombre }}
                                                </span>
                                            </b-form-radio>
                                        </div>
                                    </b-list-group-item>
                                </b-list-group>
                            </div>

                            <div v-if="cuentasFiltradas.length === 0" class="text-center py-3 text-muted">
                                <b-icon icon="search" font-scale="1.5"></b-icon>
                                <p class="mt-2">{{ labels.noAccountsFound }}</p>
                            </div>

                            <!-- Botón para agregar registro -->
                            <div class="mt-4 text-right">
                                <b-button @click="agregarRegistro" variant="success" :disabled="!puedeAgregarRegistro">
                                    <b-icon icon="plus-circle" class="me-2"></b-icon>
                                    {{ registroActual.id ? labels.updateRecord : labels.addRecord }}
                                </b-button>
                            </div>
                        </div>
                    </div>
                </b-card>

                <b-row class="mt-4">
                    <b-col md="12" class="d-flex justify-content-between">
                        <b-button v-if="modoEdicion" @click="eliminarGrupoCompleto" variant="danger" class="px-4">
                            <b-icon icon="trash" class="me-2"></b-icon>
                            {{ labels.deleteCompleteGroup }}
                        </b-button>
                        <div v-else></div>

                        <div>
                            <b-button type="button" variant="secondary" @click="cerrarModal" class="me-2 px-4">
                                {{ labels.cancel }}
                            </b-button>
                            <b-button type="submit" variant="primary" class="px-4" :disabled="isLoading">
                                <b-spinner small v-if="isLoading" class="mr-2"></b-spinner>
                                {{ modoEdicion ? labels.update : labels.save }}
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import GruposIntercosService from "@/services/GruposIntercos"
import CompanyService from "@/services/Company"
import PlanCuentasService from "@/services/PlanCuentas"

const toLower = (text) => {
    return text.toString().toLowerCase();
};

const searchByInterco = (items, term) => {
    if (term) {
        return items.filter((item) =>
            toLower(item.interco).includes(toLower(term))
        );
    }
    return items;
};

const searchByDescripcion = (items, term) => {
    if (term) {
        const termLower = toLower(term);
        return items.filter((item) =>
            toLower(item.descripcion).includes(termLower)
        );
    }
    return items;
};

export default {
    name: "GruposIntercos",

    data: () => ({
        isLoading: false,
        isLoadingCuentas: false,
        showModal: false,
        modoEdicion: false,
        searchInterco: '',
        searchDescripcion: '',
        searchCuenta: '',
        listGruposIntercos: [],
        listGruposIntercosOrigen: [],
        registrosActivos: [],

        registroActual: {
            id: null,
            id_compania: null,
            cuentas: '',
            compania_nombre: ''
        },

        companias: [],
        companiaSeleccionada: null,
        vigenciaSeleccionada: null,
        vigencias: [],
        cuentasDisponibles: [],
        cuentaSeleccionada: null,

        formulario: {
            interco: null,
            descripcion: '',
            registros: []
        },
        itemLimit: 100,
        visibleItems: [],
        limitOptions: [
            { value: 100, text: '100 registros' },
            { value: 200, text: '200 registros' },
            { value: 500, text: '500 registros' },
            { value: 0, text: 'Mostrar todo' }
        ]
    }),

    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Gestión de Grupos Intercos",
                    createGroup: "Crear Grupo",
                    editGroup: "Editar Grupo",
                    searchByInterco: "Buscar por Interco",
                    searchByDescription: "Buscar por Descripción",
                    interco: "Interco",
                    description: "Descripción",
                    enterInterco: "Ingrese el número de interco",
                    enterDescription: "Ingrese la descripción",
                    characters: "caracteres",
                    cancel: "Cancelar",
                    save: "Guardar",
                    update: "Actualizar",
                    delete: "Eliminar",
                    clear: "Limpiar",
                    showing: "Mostrando",
                    of: "de",
                    records: "registros",
                    noData: "No hay datos para mostrar",
                    actions: "Acciones",
                    noSelected: "No seleccionada",


                    existingRecords: "Registros Existentes",
                    existingRecordsHelp: "Este grupo interco tiene cuentas asignadas en las siguientes compañías. Puede editar o eliminar cada registro.",
                    addRecord: "Agregar Registro",
                    editRecord: "Editar Registro",
                    updateRecord: "Actualizar Registro",
                    deleteCompleteGroup: "Eliminar Grupo Completo",
                    selectVigency: "Seleccione una vigencia",
                    recordAdded: "Registro agregado",
                    recordUpdated: "Registro actualizado",
                    recordDeleted: "Registro eliminado",
                    confirmDeleteRecord: "¿Eliminar este registro?",
                    confirmDeleteGroup: "¿Eliminar todo el grupo interco?",


                    assignAccounts: "Asignar Cuentas al Grupo",
                    accountSelectionHelp: "Seleccione una compañía y luego las cuentas que desea asociar a este grupo interco. Estas cuentas se marcarán automáticamente en el plan de cuentas.",
                    selectCompany: "Seleccionar Compañía",
                    selectCompanyOption: "-- Seleccione una compañía --",
                    vigency: "Vigencia",
                    searchAccount: "Buscar Cuenta",
                    searchAccountPlaceholder: "Buscar por código o nombre...",
                    availableAccounts: "Cuentas Disponibles",
                    selected: "Seleccionadas",
                    selectedAccounts: "Cuentas Seleccionadas",
                    selectCompanyFirst: "Seleccione una compañía para ver las cuentas disponibles",
                    noAccountsFound: "No se encontraron cuentas con ese criterio",
                    remove: "Remover",
                    loadingCompanies: "Cargando compañías...",
                    noVigenciesAvailable: "No hay vigencias disponibles",
                    vigenciesAvailable: "vigencias disponibles",
                }
            } else {
                return {
                    title: "Intercos Groups Management",
                    createGroup: "Create Group",
                    editGroup: "Edit Group",
                    searchByInterco: "Search by Interco",
                    searchByDescription: "Search by Description",
                    interco: "Interco",
                    description: "Description",
                    enterInterco: "Enter interco number",
                    enterDescription: "Enter description",
                    characters: "characters",
                    cancel: "Cancel",
                    save: "Save",
                    update: "Update",
                    delete: "Delete",
                    clear: "Clear",
                    showing: "Showing",
                    of: "of",
                    records: "records",
                    noData: "No data to display",
                    actions: "Actions",

                    existingRecords: "Existing Records",
                    existingRecordsHelp: "This interco group has accounts assigned in the following companies. You can edit or delete each record.",
                    addRecord: "Add Record",
                    editRecord: "Edit Record",
                    updateRecord: "Update Record",
                    deleteCompleteGroup: "Delete Complete Group",
                    selectVigency: "Select a vigency",
                    recordAdded: "Record added",
                    recordUpdated: "Record updated",
                    recordDeleted: "Record deleted",
                    confirmDeleteRecord: "Delete this record?",
                    confirmDeleteGroup: "Delete the entire interco group?",

                    assignAccounts: "Assign Accounts to Group",
                    accountSelectionHelp: "Select a company and then the accounts you want to associate with this interco group. These accounts will be automatically marked in the chart of accounts.",
                    selectCompany: "Select Company",
                    selectCompanyOption: "-- Select a company --",
                    vigency: "Vigency",
                    searchAccount: "Search Account",
                    searchAccountPlaceholder: "Search by code or name...",
                    availableAccounts: "Available Accounts",
                    selected: "Selected",
                    selectedAccounts: "Selected Accounts",
                    selectCompanyFirst: "Select a company to see available accounts",
                    noAccountsFound: "No accounts found with that criteria",
                    remove: "Remove",
                    loadingCompanies: "Loading companies...",
                    noVigenciesAvailable: "No vigencies available",
                    vigenciesAvailable: "vigencies available",
                    noSelected: "Not selected",
                }
            }

        },

        puedeAgregarRegistro() {
            // Validar que haya compañía seleccionada
            if (!this.companiaSeleccionada) {
                console.log('No se puede agregar: falta compañía seleccionada');
                return false;
            }

            // Validar que haya cuenta seleccionada
            if (!this.cuentaSeleccionada) {
                console.log('No se puede agregar: falta cuenta seleccionada');
                return false;
            }

            // Validar que la compañía sea única (no duplicada)
            const companiaValida = this.validarCompaniaUnica();
            if (!companiaValida) {
                console.log('No se puede agregar: compañía duplicada');
                return false;
            }

            console.log('Se puede agregar registro - condiciones cumplidas');
            return true;
        },

        companiasOptions() {
            console.log('Compañías disponibles:', this.companias);
            return this.companias.map(compania => ({
                value: compania.id,
                text: compania.nombre || compania.nombre_compania || 'Sin nombre'
            }));
        },

        vigenciasOptions() {
            console.log('Generando vigenciasOptions:', this.vigencias);

            if (!this.vigencias || this.vigencias.length === 0) {
                return [];
            }

            return this.vigencias.map(vigencia => {
                const valor = vigencia.vigencia || vigencia;
                const texto = typeof valor === 'number' ? valor.toString() : valor;
                return {
                    value: valor,
                    text: texto
                };
            });
        },

        cuentasFiltradas() {
            if (!this.searchCuenta) {
                return this.cuentasDisponibles;
            }
            const searchTerm = toLower(this.searchCuenta);
            return this.cuentasDisponibles.filter(cuenta =>
                toLower(cuenta.codigo).includes(searchTerm) ||
                toLower(cuenta.nombre).includes(searchTerm)
            );
        }
    },

    methods: {
        async cargarGrupos() {
            this.isLoading = true;
            try {
                const response = await GruposIntercosService.getAllGruposIntercos();

                this.listGruposIntercos = response.data.gruposIntercos || [];

                this.listGruposIntercos.forEach(grupo => {
                    if (!grupo.cuentas && grupo.registros) {
                        grupo.cuentas = grupo.registros
                            .map(r => r.cuentas)
                            .filter(c => c)
                            .join(', ');
                    }
                });

                this.listGruposIntercosOrigen = [...this.listGruposIntercos];
                this.resetVisibleItems();

                console.log(`Grupos cargados: ${this.listGruposIntercos.length} registros`);

            } catch (error) {
                console.error('Error cargando grupos:', error);
                this.$bvToast.toast('Error cargando grupos intercos', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true
                });
            } finally {
                setTimeout(() => {
                    this.isLoading = false;
                }, 300);
            }
        },

        validarCompaniaUnica() {
            if (!this.companiaSeleccionada) return null;

            // Verificar si ya existe un registro con esta compañía
            const existe = this.registrosActivos.some(registro =>
                registro.id_compania === this.companiaSeleccionada &&
                registro.id !== this.registroActual.id
            );

            return !existe;
        },

        obtenerNombreCuentaSeleccionada() {
            if (!this.cuentaSeleccionada) return '';
            const cuenta = this.cuentasDisponibles.find(c => c.id === this.cuentaSeleccionada);
            return cuenta ? `${cuenta.codigo} - ${cuenta.nombre}` : '';
        },

        actualizarCuentaSeleccionada() {
            console.log('Cuenta seleccionada:', this.cuentaSeleccionada);
        },


        async cargarCuentasPorCompania() {
            console.log('cargarCuentasPorCompania llamado con:', {
                compania: this.companiaSeleccionada,
                vigencia: this.vigenciaSeleccionada
            });

            if (!this.companiaSeleccionada) {
                this.cuentasDisponibles = [];
                this.cuentaSeleccionada = null;
                return;
            }

            if (!this.vigenciaSeleccionada && this.vigencias.length > 0) {
                const primeraVigencia = this.vigencias[0];
                this.vigenciaSeleccionada = primeraVigencia.vigencia || primeraVigencia;
            }

            if (!this.vigenciaSeleccionada) {
                this.cuentasDisponibles = [];
                this.cuentaSeleccionada = null;
                return;
            }

            this.isLoadingCuentas = true;
            try {
                const response = await PlanCuentasService.planCuentPorCompaVig(
                    this.companiaSeleccionada,
                    this.vigenciaSeleccionada
                );

                let cuentas = [];
                if (response.data) {
                    if (response.data.planCuentas && Array.isArray(response.data.planCuentas)) {
                        cuentas = response.data.planCuentas;
                    } else if (Array.isArray(response.data)) {
                        cuentas = response.data;
                    } else if (response.data.data && Array.isArray(response.data.data)) {
                        cuentas = response.data.data;
                    }
                }

                const compania = this.companias.find(c => c.id === this.companiaSeleccionada);

                this.cuentasDisponibles = cuentas.map(cuenta => ({
                    ...cuenta,
                    codigo: cuenta.codigo || cuenta.cuenta || 'N/A',
                    nombre: cuenta.nombre || cuenta.descripcion || 'Sin nombre',
                    compania_nombre: compania ? (compania.nombre || compania.nombre_compania || 'Sin nombre') : 'Sin nombre'
                }));

                // Si estamos editando un registro existente, marcar la cuenta
                if (this.registroActual.id && this.registroActual.cuentas) {
                    const cuentaParaMarcar = this.cuentasDisponibles.find(cuenta => {
                        const codigoCuenta = cuenta.codigo || cuenta.cuenta;
                        return codigoCuenta === this.registroActual.cuentas;
                    });

                    if (cuentaParaMarcar) {
                        this.cuentaSeleccionada = cuentaParaMarcar.id;
                    }
                } else {
                    this.cuentaSeleccionada = null;
                }

            } catch (error) {
                console.error('Error cargando cuentas:', error);
                this.cuentasDisponibles = [];
                this.cuentaSeleccionada = null;
            } finally {
                this.isLoadingCuentas = false;
            }
        },

        agregarRegistro() {
            if (!this.puedeAgregarRegistro) return;

            const cuentaSeleccionada = this.cuentasDisponibles.find(c => c.id === this.cuentaSeleccionada);
            const companiaSeleccionada = this.companias.find(c => c.id === this.companiaSeleccionada);

            const nuevoRegistro = {
                id: this.registroActual.id,
                id_compania: this.companiaSeleccionada,
                cuentas: cuentaSeleccionada.codigo || cuentaSeleccionada.cuenta,
                compania_nombre: companiaSeleccionada?.nombre || companiaSeleccionada?.nombre_compania || 'Sin nombre'
            };

            if (this.registroActual.id) {
                const index = this.registrosActivos.findIndex(r => r.id === this.registroActual.id);
                if (index !== -1) {
                    this.registrosActivos[index] = { ...this.registrosActivos[index], ...nuevoRegistro };
                    // Usar toast como en CreaFila.vue
                    this.$toast.success(this.labels.recordUpdated);
                }
            } else {
                this.registrosActivos.push(nuevoRegistro);
                this.$toast.success(this.labels.recordAdded);
            }

            this.resetSeleccionActual();
        },

        editarRegistroExistente(registro) {
            this.registroActual = { ...registro };
            this.companiaSeleccionada = registro.id_compania;

            // Cargar las cuentas para esta compañía
            this.$nextTick(() => {
                this.cargarCuentasPorCompania();
            });
        },

        async eliminarRegistro(registro) {
            const message = this.$store.state._language == "es-ES"
                ? "¿Está seguro que desea eliminar este registro?"
                : "Are you sure you want to delete this record?";

            if (!confirm(message)) return;

            if (registro.id) {
                try {
                    await GruposIntercosService.deleteGrupoInterco(registro.id);
                } catch (error) {
                    console.error('Error eliminando registro:', error);
                    this.$toast.error('Error eliminando registro');
                    return;
                }
            }

            this.registrosActivos = this.registrosActivos.filter(r => r.id !== registro.id);
            this.$toast.success(this.labels.recordDeleted);
        },

        async eliminarGrupoCompleto() {
            const message = this.labels.confirmDeleteGroup;
            const title = this.$store.state._language === "es-ES"
                ? 'Confirmar eliminación'
                : 'Confirm deletion';

            const confirmed = await this.$bvModal.msgBoxConfirm(message, {
                title: title,
                okVariant: 'danger',
                okTitle: this.$store.state._language === "es-ES" ? 'Eliminar' : 'Delete',
                cancelTitle: this.$store.state._language === "es-ES" ? 'Cancelar' : 'Cancel',
                centered: true,
                footerClass: 'p-2'
            });

            if (!confirmed) return;

            this.isLoading = true;

            this.showModal = false;

            const intercoAEliminar = this.formulario.interco;

            try {

                const timeoutPromise = new Promise((_, reject) => {
                    setTimeout(() => reject(new Error('Timeout')), 5000);
                });

                await Promise.race([
                    GruposIntercosService.deleteGrupoIntercoCompleto(intercoAEliminar),
                    timeoutPromise
                ]);

            } catch (error) {
                console.log('Operación de eliminación completada:', error.message || error);

                this.$toast.success(
                    this.$store.state._language === "es-ES"
                        ? 'Los datos han sido actualizados correctamente'
                        : 'Data has been successfully updated',
                );
            }

            try {
                await this.cargarGrupos();
            } catch (loadError) {
                console.log('Error recargando datos:', loadError);
            }

            this.resetFormulario();
            this.registrosActivos = [];
            this.isLoading = false;
        },

        async guardarGrupo() {
            if (this.registrosActivos.length === 0 && !this.modoEdicion) {
                this.$toast.error('Debe agregar al menos un registro');
                return;
            }

            this.isLoading = true;
            try {
                const userId = this.$store.state.userId || 1;
                let grupoActualizado = null;

                if (this.modoEdicion) {
                    // Para edición: actualizar cada registro
                    for (const registro of this.registrosActivos) {
                        const formData = {
                            id: registro.id,
                            interco: this.formulario.interco,
                            descripcion: this.formulario.descripcion,
                            cuentas: registro.cuentas,
                            id_compania: registro.id_compania,
                            userId: userId
                        };

                        if (registro.id) {
                            await GruposIntercosService.updateGrupoInterco(formData);
                        } else {
                            await GruposIntercosService.createGrupoInterco({
                                interco: this.formulario.interco,
                                descripcion: this.formulario.descripcion,
                                registros: [{
                                    id_compania: registro.id_compania,
                                    cuentas: registro.cuentas
                                }],
                                userId: userId
                            });
                        }
                    }

                    grupoActualizado = {
                        interco: this.formulario.interco,
                        descripcion: this.formulario.descripcion,
                        registros: this.registrosActivos
                    };

                    this.$toast.success('Grupo actualizado exitosamente');

                } else {

                    const registrosParaEnviar = this.registrosActivos.map(registro => ({
                        id_compania: registro.id_compania,
                        cuentas: registro.cuentas
                    }));

                    const formData = {
                        interco: this.formulario.interco,
                        descripcion: this.formulario.descripcion,
                        registros: registrosParaEnviar,
                        userId: userId
                    };

                    const response = await GruposIntercosService.createGrupoInterco(formData);
                    grupoActualizado = response.data?.grupoInterco || {
                        interco: this.formulario.interco,
                        descripcion: this.formulario.descripcion,
                        registros: registrosParaEnviar
                    };

                    this.$toast.success('Grupo creado exitosamente');
                }

                this.cerrarModal();

                await this.actualizarTablaDespuesDeGuardar(grupoActualizado);

            } catch (error) {
                console.error('Error guardando grupo:', error);

                let errorMessage = 'Error al guardar el grupo';
                if (error.response && error.response.data) {
                    errorMessage = error.response.data.message || errorMessage;
                }

                this.$toast.error(errorMessage);
            } finally {
                this.isLoading = false;
            }
        },

        async actualizarTablaDespuesDeGuardar(grupoActualizado) {
            try {
                this.isLoading = true;

                this.ultimoGrupoEditado = grupoActualizado.interco;

                await this.cargarGrupos();

                setTimeout(() => {
                    this.ultimoGrupoEditado = null;
                }, 2000);

            } catch (error) {
                console.error('Error actualizando tabla:', error);
                await this.cargarGrupos();
            }
        },

        async cargarCompanias() {
            try {
                const response = await CompanyService.getAllCompanies();
                console.log('Respuesta completa de compañías:', response);

                if (response.data && response.data.companies) {
                    this.companias = response.data.companies;
                } else if (response.data && Array.isArray(response.data)) {
                    this.companias = response.data;
                } else if (response.data && response.data.data) {
                    this.companias = response.data.data;
                } else {
                    this.companias = [];
                }

                console.log('Compañías procesadas:', this.companias);
            } catch (error) {
                console.error('Error cargando compañías:', error);
                this.companias = [];
            }
        },

        async cargarVigencias() {
            try {
                console.log('Iniciando carga de vigencias...');
                const response = await PlanCuentasService.getVigenciaPlancuentas();
                console.log('Respuesta completa de vigencias:', response);

                if (response.data && response.data.getVigencia) {
                    this.vigencias = response.data.getVigencia;
                } else if (response.data && Array.isArray(response.data)) {
                    this.vigencias = response.data;
                } else {
                    this.vigencias = [];
                }

                console.log('Vigencias procesadas:', this.vigencias);

                if (this.vigencias.length > 0) {
                    this.vigencias = this.vigencias.map(v => {
                        if (v && typeof v === 'object' && 'vigencia' in v) {
                            return v;
                        } else {
                            return { vigencia: v };
                        }
                    });

                    this.vigencias.sort((a, b) => a.vigencia - b.vigencia);

                } else {
                    console.log('No hay vigencias disponibles');
                    this.vigenciaSeleccionada = null;
                }

            } catch (error) {
                console.error('Error cargando vigencias:', error);
                this.vigencias = [];
                this.vigenciaSeleccionada = null;
            }
        },

        actualizarSeleccion() {
            console.log('Cuenta seleccionada:', this.cuentaSeleccionada);
        },


        marcarCuentasDeEstaCompania(cuentasDeCompania) {
            console.log('Marcando cuentas específicas de esta compañía...');
            console.log('Cuentas de compañía a marcar:', cuentasDeCompania);

            const codigosDeEstaCompania = cuentasDeCompania
                .map(c => c.codigo || c.cuenta)
                .filter(c => c);

            console.log('Códigos a buscar en esta compañía:', codigosDeEstaCompania);

            for (const cuenta of this.cuentasDisponibles) {
                const codigoCuenta = cuenta.codigo || cuenta.cuenta;
                if (codigoCuenta && codigosDeEstaCompania.includes(codigoCuenta)) {
                    if (!this.cuentasSeleccionadas.includes(cuenta.id)) {
                        this.cuentasSeleccionadas.push(cuenta.id);
                        console.log('Cuenta marcada automáticamente:', {
                            id: cuenta.id,
                            codigo: codigoCuenta,
                            nombre: cuenta.nombre
                        });
                    }
                }
            }

            console.log('Total de cuentas marcadas para esta compañía:', this.cuentasSeleccionadas.length);
        },

        removerCuentaSeleccionada(cuentaId) {
            this.cuentasSeleccionadas = this.cuentasSeleccionadas.filter(id => id !== cuentaId);
        },

        obtenerCuentaPorId(cuentaId) {
            return this.cuentasDisponibles.find(c => c.id === cuentaId);
        },

        mostrarModalCrear() {
            this.modoEdicion = false;
            this.resetFormulario();
            this.resetSeleccionCuentas();
            this.registrosActivos = [];
            this.showModal = true;
        },

        async editarGrupo(grupo) {
            console.log('Editando grupo:', grupo);

            this.modoEdicion = true;

            // Cargar todos los registros de este grupo interco
            try {
                const response = await GruposIntercosService.getGrupoIntercoById(grupo.id || grupo.registros?.[0]?.id);
                const grupoCompleto = response.data.gruposIntercos;

                // Configurar formulario base
                this.formulario = {
                    interco: grupoCompleto.interco,
                    descripcion: grupoCompleto.descripcion,
                    registros: grupoCompleto.registros || []
                };

                // Guardar registros activos para mostrar en la UI
                this.registrosActivos = grupoCompleto.registros || [];

                console.log('Registros del grupo:', this.registrosActivos);

                // Resetear selección actual
                this.resetSeleccionActual();

                this.$nextTick(() => {
                    this.showModal = true;
                });

            } catch (error) {
                console.error('Error cargando detalles del grupo:', error);
                this.$bvToast.toast('Error cargando detalles del grupo', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true
                });
            }
        },



        resetSeleccionActual() {
            this.registroActual = {
                id: null,
                id_compania: null,
                cuentas: '',
                compania_nombre: ''
            };
            this.companiaSeleccionada = null;
            this.vigenciaSeleccionada = null;
            this.cuentasDisponibles = [];
            this.cuentaSeleccionada = null;
            this.searchCuenta = '';
        },

        async eliminarGrupo(id) {
            if (confirm('¿Está seguro de eliminar este grupo?')) {
                this.isLoading = true;
                try {
                    await GruposIntercosService.deleteGrupoInterco(id);
                    this.cerrarModal();
                    this.cargarGrupos();
                } catch (error) {
                    console.error('Error eliminando grupo:', error);
                } finally {
                    this.isLoading = false;
                }
            }
        },

        cerrarModal() {
            this.showModal = false;
            this.resetFormulario();
            this.resetSeleccionCuentas();
            this.registrosActivos = [];
            this.codigoCuentaGuardada = null;
        },

        resetFormulario() {
            this.formulario = {
                interco: null,
                descripcion: '',
                registros: []
            };
            this.registrosActivos = [];
        },

        resetSeleccionCuentas() {
            this.companiaSeleccionada = null;
            this.vigenciaSeleccionada = null;
            this.cuentasDisponibles = [];
            this.cuentaSeleccionada = null;
            this.codigoCuentaGuardada = null;
            this.searchCuenta = '';
            this.registrosActivos = [];
        },

        borraCriterio() {
            this.searchInterco = '';
            this.searchDescripcion = '';
            this.listGruposIntercos = [...this.listGruposIntercosOrigen];
            this.resetVisibleItems();
        },

        searchOnTableInterco() {
            this.listGruposIntercos = searchByInterco(this.listGruposIntercosOrigen, this.searchInterco);
            if (this.searchInterco === '') {
                this.listGruposIntercos = [...this.listGruposIntercosOrigen];
            }
            this.resetVisibleItems();
        },

        searchOnTableDescripcion() {
            this.listGruposIntercos = searchByDescripcion(this.listGruposIntercosOrigen, this.searchDescripcion);
            if (this.searchDescripcion === '') {
                this.listGruposIntercos = [...this.listGruposIntercosOrigen];
            }
            this.resetVisibleItems();
        },

        resetVisibleItems() {
            if (this.itemLimit === 0) {
                this.visibleItems = [...this.listGruposIntercos];
            } else {
                this.visibleItems = this.listGruposIntercos.slice(0, this.itemLimit);
            }
        },

        formatoFecha(fecha) {
            return new Date(fecha).toLocaleDateString('es-ES');
        }
    },

    async mounted() {
        this.isLoading = true;
        console.log('Iniciando carga de datos...');

        try {
            // Cargar compañías primero
            console.log('Cargando compañías...');
            await this.cargarCompanias();

            // Cargar vigencias segundo
            console.log('Cargando vigencias...');
            await this.cargarVigencias();

            // Cargar grupos intercos
            console.log('Cargando grupos intercos...');
            await this.cargarGrupos();

            console.log('Todos los datos cargados exitosamente');
        } catch (error) {
            console.error('Error en mounted:', error);
        } finally {
            this.isLoading = false;
        }
    }
}
</script>

<style src="@/components/main.css"></style>

<style scoped>
.cuentas-container {
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
    padding: 10px;
}

.selected-accounts-container {
    max-height: 200px;
    overflow-y: auto;
}

.clickable-row:hover {
    background-color: #f8f9fa;
}

.list-group-item:hover {
    background-color: #f8f9fa;
}

/* Nuevos estilos para las mejoras */
.cuentas-lista {
    font-size: 0.9rem;
    line-height: 1.4;
}

.cuentas-lista strong {
    color: #2c3e50;
    font-weight: 600;
}

.btn-group-sm>.btn {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
}

.btn-outline-primary {
    border-color: #3498db;
    color: #3498db;
}

.btn-outline-primary:hover {
    background-color: #3498db;
    border-color: #3498db;
    color: white;
}

.btn-outline-danger {
    border-color: #e74c3c;
    color: #e74c3c;
}

.btn-outline-danger:hover {
    background-color: #e74c3c;
    border-color: #e74c3c;
    color: white;
}

.btn-group {
    display: flex;
    gap: 2px;
}

.btn-edit-minimal {
    min-width: 40px !important;
    width: 40px !important;
    height: 40px !important;
    padding: 0 !important;
    margin: 0 2px !important;
    border-radius: 6px !important;
    background-color: transparent !important;
    transition: all 0.2s ease !important;
    border: 1px solid #3498db !important;
}

.btn-edit-minimal:hover {
    background-color: rgba(52, 152, 219, 0.1) !important;
}

.btn-edit-minimal:active {
    background-color: rgba(52, 152, 219, 0.2) !important;
}

.btn-edit-minimal .b-icon {
    color: #3498db !important;
    font-size: 18px !important;
    transition: transform 0.2s ease !important;
}

.btn-edit-minimal:hover .b-icon {
    transform: scale(1.1);
    color: #2980b9 !important;
}

.btn-group {
    display: flex;
    gap: 4px;
}

.table-sm tbody tr:hover {
    background-color: #f8f9fa !important;
}

.table-sm .btn-group-sm>.btn {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
}
</style>